import { withGlobalValue } from './withGlobalValue';

// We're casting so that we get better autocomplete for the returned variable names.

// Returns the current css prefix and a function to set the global prefix.
export const useCSSPrefix = withGlobalValue('cfa') as (
  cssPrefixOverride?: string
) => [cssPrefix: string, setGlobalCSSPrefix: (newPrefix: string) => void];
